// App-wide constants shared across features.

// Default page size for paginated list views (consumed by shared/api/crudApi.ts).
export const PAGE_SIZE = 20;

// React Query staleness window used by the query client default (see shared/queryClient.ts).
export const DEFAULT_STALE_TIME = 60_000;

// Version prefix every API path carries. Kept here so the refresh flow in
// shared/api/httpClient.ts and each feature's *Api.ts agree on one value.
export const API_PREFIX = '/api/v1';
